import { identity } from '@kofno/piper';
import { FilterOption, Success } from './Types';

export const options = (state: Success) => {
  switch (state.kind) {
    case 'ready':
    case 'filtering':
      return [];
    case 'filtered':
      return state.optionsResource.payload;
    case 'option-selected':
      const selectedValue = state.selectedValue;
      return state.optionsResource.payload.filter((option) => option.value === selectedValue.value);
  }
};

export const selectedValue = (state: Success) => {
  switch (state.kind) {
    case 'ready':
    case 'filtering':
      return undefined;
    case 'filtered':
      return state.selectedValue.map<FilterOption | undefined>(identity).getOrElseValue(undefined);
    case 'option-selected':
      return state.selectedValue;
  }
};
